import styled from "styled-components";
import React from "react";
// import {maxWidth} from '../common/StyleValue'
import SelectionItem from "./SelectionItem";
import Daoavatar from "../../assets/img/dao_avatar.png";
import Triasgrant from "../../assets/img/trias_grant.png";
import Triasures_cover from "../../assets/img/triasures_cover.png";
import Antifraud_cover from "../../assets/img/antifraud_index_cover.png";
import Triasures_avatar from "../../assets/img/triasures_avatar.png";
import AuctionCover from "../../assets/img/auction_cover.png";

const SelectBox = styled.div`
  width: 1080px;
  margin: auto;
  margin-top: 60px;
  > h2 {
    font-size: 36px;
    font-weight: 700;
    color: #2b2f37;
    line-height: 42px;
  }
  .top-box {
    display: flex;
    justify-content: space-between;
    line-height: 26px;
    flex-wrap: wrap;
    > div:first-child {
      color: #666666;
      margin-top: 10px;
      margin-right: 15px;
    }
    > a {
      margin-top: 10px;
      color: #3d6de5;
      font-weight: 500;
      text-decoration: none;
      &:hover {
        color: #0341dc;
      }
      > .fa {
        font-size: 20px;
        margin-left: 6px;
      }
    }
  }
  .list-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 0 20px;
  }
`;

export default function Selections() {
  const items = [
    {
      bgurl: Triasgrant,
      avatar: Daoavatar,
      name: "DAOeco",
      title: "Research for Quadratic Voting",
      desc: "DAOeco wants to design a Quadratic Voting scheme for Trias Grant.",
      page: "#/donate",
    },
    {
      bgurl: Triasures_cover,
      avatar: Triasures_avatar,
      name: "Trias Foundation",
      title: "TRIAS Treasure Hunting: Triasures Go",
      desc: "Become Trias Hunters, and win 1000 TRIAS!",
      page: "#/triasures",
    },
    {
      bgurl: Antifraud_cover,
      avatar: Triasures_avatar,
      name: "Trias Foundation",
      title: "Trias Anti-fraud Volunteer Alliance",
      desc: "Protect Trias users from fraud information",
      page: "#/antifraud",
    },
    {
      bgurl: AuctionCover,
      avatar: Daoavatar,
      name: "DAOeco",
      title: "Research for NFT Auction",
      desc: "DAOeco wants to design an NFT protocol with auction mechanism.",
      page: "#/researchAuction",
    },
  ];

  let selects = items
    // .reverse()
    .map((item) => <SelectionItem key={item.page} {...item}></SelectionItem>);
  if (items.length % 2 !== 0) {
    selects.push(<SelectionItem key={0} empty></SelectionItem>);
  }

  return (
    <SelectBox>
      <h2>Grants</h2>
      <div className="top-box">
        <div>Selections of grants curated by the community</div>
        <a href="#/">
          View all grants
          <i className="fa fa-arrow-right"></i>
        </a>
      </div>
      <ul className="list-box">{selects}</ul>
    </SelectBox>
  );
}
